import Navbar from "pages/PanelPage/components/Navbar/Navbar";

export default Navbar;
